/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import { Link } from 'react-router-dom';

import {
  BLACK,
  GREEN_LIGHT,
  PURPLE_LIGHT,
  GREEN_STATUS,
  PURPLE_MEDIUM,
} from 'styles/colors';
import Icon from 'components/Icon';
import Text from 'components/Text';
import { MEDIA_QUERIES } from 'styles/constants';
import { ROUTES_FEEKAPP } from 'constants/routes';
import { ReactComponent as Zap } from 'assets/icons/Zap.svg';
import { ReactComponent as ArrowDownPesoMini } from 'assets/icons/ArrowDownPesoMini.svg';

const styles = css`
  border-radius: 20px;
  padding: 10px;
  width: 500px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-bottom: 100px;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.15);

  :nth-child(3n + 1) {
    align-self: center;
    background-color: ${GREEN_LIGHT};
  }
  :nth-child(3n + 2) {
    align-self: flex-end;
    background-color: ${PURPLE_MEDIUM};
  }
  :nth-child(3n + 3) {
    align-self: flex-start;
    background-color: ${PURPLE_LIGHT};
  }

  :nth-child(4n + 1) {
    background-color: ${GREEN_STATUS};
  }
  :nth-child(4n + 2) {
    background-color: ${PURPLE_MEDIUM};
  }
  :nth-child(4n + 3) {
    background-color: ${PURPLE_LIGHT};
  }

  .campaign-small-card:nth-child(4n + 4) {
    background-color: ${GREEN_LIGHT};
  }

  .campaign-small-card-image {
    width: 110px;
    height: 110px;
    border-radius: 10px;
    margin-right: 10px;
    object-fit: cover;
    object-position: center;
  }

  .campaign-small-card-info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .campaign-small-country-badge {
    border-radius: 30px;
    border: 1px solid ${BLACK};
    text-transform: uppercase;
    width: fit-content;
    padding: 6px 9px;
  }

  .flexRow {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .ellipsed {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  ${MEDIA_QUERIES.mobile} {
    margin: 0px 5px;

    .campaign-small-card-image {
      width: 80px;
      height: 80px;
    }

    .upperCase {
      leading-trim: both;
      text-edge: cap;
      font-family: Roobert;
      font-size: 12px;
      font-style: normal;
      line-height: 120%; /* 12px */
      text-transform: uppercase;
    }

    .campaign-small-card-info {
      min-width: 220px;
    }

    .campaign-small-country-badge {
      font-size: 8px;
      border-radius: 30px;
      text-transform: uppercase;
      width: fit-content;
      padding: 3px 4px;
    }

    .flexRow {
      font-size: 8px;
    }

    .flexRow svg {
      width: 10px;
      height: 10px;
    }
  }
`;

const CampaignSmallCard = ({
  image,
  location,
  feekspot,
  title,
  type,
  feekpoints,
}) => {
  return (
    <Link to={ROUTES_FEEKAPP.EXPLORE} css={styles}>
      {image && (
        <img
          src={image}
          alt={'Feek ' + feekspot}
          className="campaign-small-card-image"
          width={110}
          height={110}
        />
      )}
      <div className="campaign-small-card-info">
        <Text
          color={BLACK}
          fontWeight={700}
          className="campaign-small-country-badge"
        >
          {location}
        </Text>
        <div>
          <Text
            color={BLACK}
            fontSize={22}
            fontWeight={700}
            className="upperCase ellipsed"
          >
            {feekspot}
          </Text>
          <Text
            color={BLACK}
            fontSize={16}
            fontWeight={200}
            className="upperCase ellipsed"
          >
            {title}
          </Text>
        </div>
        <div className="flexRow">
          <div className="flexRow">
            <Icon
              icon={ArrowDownPesoMini}
              color={BLACK}
              className="me-1"
            />
            <Text color={BLACK} className="me-2">
              {type?.name}
            </Text>
          </div>
          <div className="flexRow">
            <Icon icon={Zap} color={BLACK} className="me-1" />
            <Text color={BLACK}>+{feekpoints}</Text>
          </div>
        </div>
      </div>
    </Link>
  );
};

CampaignSmallCard.propTypes = {
  image: PropTypes.string,
  type: PropTypes.object,
  location: PropTypes.string,
  feekspot: PropTypes.string,
  title: PropTypes.string,
  feekpoints: PropTypes.number,
  style: PropTypes.object,
};

export default CampaignSmallCard;
